import { matchPath } from 'react-router-dom';

import { ROUTES } from '#client/manifest';

const PAGE_SECTION_ROUTES = {
  account: [
    ROUTES.accountSettings,
    ROUTES.download,
    ROUTES.help,
    ROUTES.payments
  ],
  banking: [
    ROUTES.banking,
    ROUTES.bankingUI,
    ROUTES.bankOfAmericaOffer
  ],
  business: [
    ROUTES.businessOverview,
    ROUTES.businessProfile,
    `${ROUTES.orders}/*`,
    ROUTES.subscriptions
  ],
  documents: [
    ROUTES.amendments,
    ROUTES.annualReports,
    `${ROUTES.businessRecords}/*`,
    `${ROUTES.documentTemplates}/*`,
    ROUTES.worryFreeCompliance
  ],
  education: [
    `${ROUTES.educationStudio}/*`
  ],
  home: [
    ROUTES.company,
    ROUTES.dashboard,
    ROUTES.logout
  ],
  insights: [
    ROUTES.insightsUI
  ],
  money: [
    ROUTES.accounting,
    ROUTES.expenses,
    ROUTES.expenseTracker,
    ROUTES.income,
    `${ROUTES.moneyLandingPage}/*`,
    ROUTES.taxes,
    ROUTES.taxServices
  ],
  growth: [
    `${ROUTES.marketingTools}/*`
  ]
};

/**
 * Returns the page section based on the given pathname.
 *
 * @param {string} pathname - The input pathname to match against PAGE_SECTION_ROUTES.
 * @returns {string} The matching page section or 'unknown', if no match is found.
 */
function getPageSection(pathname) {
  const pageSection = Object.entries(PAGE_SECTION_ROUTES).find(([, routes]) => (
    routes.find((route) => matchPath(route, pathname))
  ))?.[0];

  return pageSection || 'unknown';
}

export default getPageSection;
